import React from 'react'
import './stories.scss'

export default function Stories() {
    return (
        <div>
            <div className="d-flex flex-column justify-content-center align-items-center mx-1">
                <img className="stories-img" src="https://instagram.fcia2-2.fna.fbcdn.net/v/t51.2885-19/s150x150/149392585_3625893134126327_7880821463642696039_n.jpg?tp=1&_nc_ht=instagram.fcia2-2.fna.fbcdn.net&_nc_ohc=jLqFos_SXigAX96NK5R&oh=6cb8455732667538281fbece787dad3e&oe=6066F70C" alt=""/>
                <small></small>
            </div>
        </div>
    )
}
